export default "__VITE_ASSET__Y9E2pC1A__"